<template>
  <div id="hres37u">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchIndex"
            :data="index"
            :nowLang="dash.nowLang"
            :columns="columns[dash.nowLang].index"
            :receivedStore="receivedHres37uIndex"
            searchBoxAlias="approve"
            :detailEvent="detailEvent"
            :approveEvent="approveEvent"
            :approveRowBool="true" />

    <detail v-show="detailDisp"
            :labels="labels[dash.nowLang]"
            :labelsButton="dash.button[dash.nowLang]"
            :detail="detail"
            :toggle="toggle"
            :nowLang="dash.nowLang" />

    <div class="form-group-button" v-show="false">
      <button class="btn bg-blue" data-toggle="modal" ref="approve" data-target="#hres37u-popup-approve"><i class="fa fa-list-alt"></i> {{ btn_approve }}</button>
    </div>
    
    <popup-approve :labels="labels[dash.nowLang]"
            :nowLang="dash.nowLang"
            :labelsButton="dash.button[dash.nowLang]"
            :indexSelected="indexSelected"
            :codappr="codempid"
            :descCodappr="dash.currentUser.username[dash.nowLang]"
            :postHres37uSendApprove="postHres37uSendApprove" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hres37u/mutation-types'
import detail from 'components/hres37u/detail'
import popupApprove from 'components/hres37u/popupApprove'
import moment from 'moment'
import swal from 'sweetalert'

export default {
  name: 'hres37u',
  data () {
    return {
      dash: this.$parent.$parent.$parent,
      dtereq: moment().format('DD/MM/YYYY'),
      btn_approve: 'Approve'
    }
  },
  created () {
    this.receivedHres37uColumnsLabels()
    this.receivedHres37uIndex()
  },
  computed: {
    codempid () {
      let currentUser = this.dash.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRES37U_INDEX_DISP,
      detailDisp: types.GET_HRES37U_DETAIL_DISP,
      columns: types.GET_HRES37U_COLUMNS,
      labels: types.GET_HRES37U_LABELS,
      index: types.GET_HRES37U_INDEX,
      indexSelected: types.GET_HRES37U_INDEX_SELECTED,
      detail: types.GET_HRES37U_DETAIL
    })
  },
  methods: {
    pageDetail (event) {
      let detailParams = this.indexSelected
      this.receivedHres37uDetail(detailParams)
      this.toggle('detail')
    },
    detailEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail()
    },
    approveEvent (dataRows) {
      let dataRowsFiltered = dataRows.filter(function (dataRow) {
        return dataRow.flgStaappr !== 'undefined' && dataRow.flgStaappr !== 'P' && dataRow.flgStaappr.trim() !== ''
      })
      if (dataRowsFiltered.length > 0) {
        this.setIndexSelected(dataRowsFiltered[0])
        this.$refs.approve.click()
      } else {
        swal({
          title: 'ยืนยันการทำรายการ',
          text: 'รายการยังไม่ถูกเลือก'
        })
      }
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRES37U_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRES37U_PAGE,
      receivedHres37uColumnsLabels: types.RECEIVED_HRES37U_COLUMNS_LABELS,
      receivedHres37uIndex: types.RECEIVED_HRES37U_INDEX,
      receivedHres37uDetail: types.RECEIVED_HRES37U_DETAIL,
      postHres37uSendApprove: types.POST_HRES37U_SEND_APPROVE
    })
  },
  components: {
    detail,
    popupApprove
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?3df81d8c